export const globalObject = {}
